export default "__VITE_ASSET__baed8942__"